import { jsx as a, jsxs as o, Fragment as T } from "react/jsx-runtime";
import { u as t, a as r } from "./index-6a632112.mjs";
import { B as h } from "./themes-5f0b3c3d.mjs";
import { C as $ } from "./ChildrenCountCheck-60cafda6.mjs";
import { h as s } from "./hTag-40b23797.mjs";
import { Image as k } from "./image.js";
import { useWindowDimensions as W } from "./useWindowDimensions.js";
import { c as g } from "./index-98c703e1.mjs";
import "react";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
import "./_commonjsHelpers-d4512b9c.mjs";
const x = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.MarketingListItemWrapper)};
`, L = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ValueTextWrapper)};
`, f = t(s)`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.Value)};
`, I = t.span`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.Text)};
`, b = ({
  value: e,
  description: m,
  headingLevel: i,
  className: n
}) => /* @__PURE__ */ a(x, { className: n, children: /* @__PURE__ */ o(L, { children: [
  e && /* @__PURE__ */ a(f, { as: i || "h2", children: e }),
  m && /* @__PURE__ */ a(I, { children: m })
] }) }), v = t.div`
  &.marketingDataList-mainWrapper {
    ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.MainWrapper)};
  }
`, C = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.MarketingListItemSection)};
`, S = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ImageWrapper)};
`, w = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ChildrenWrapper)};
`, D = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.TitleSubTitleWrapper)};
`, N = t(s)`
  &.titleWrapper {
    ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.TitleWrapper)};
  }
`, j = t(s)`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.SubTitleWrapper)};
`, V = ({
  children: e,
  className: m,
  titleProp: i,
  subTitleProp: n,
  imageProp: c,
  isImageRightAligned: p,
  dataTestId: u
}) => {
  const { width: M } = W(), l = W().width < h.tabletMin, d = () => /* @__PURE__ */ a(S, { children: /* @__PURE__ */ a(
    k,
    {
      ...c,
      ratio: M < h.tabletMin ? "3:2" : "1:1",
      objectFit: c.objectFit || "fill"
    }
  ) });
  return /* @__PURE__ */ o(T, { children: [
    /* @__PURE__ */ a(
      $,
      {
        additionalInfo: "Maximun data list items count exceeded. Max 6 list items allowed in a group for marketing data list.",
        children: e,
        componentName: "marketing data list",
        maxChildren: 6
      }
    ),
    /* @__PURE__ */ o(
      v,
      {
        className: g([
          [
            `${m}`,
            "marketingDataList-mainWrapper",
            {
              "marketingDataList-mainWrapper--right": p
            }
          ]
        ]),
        "data-testid": u,
        children: [
          (!p || l) && d(),
          /* @__PURE__ */ o(C, { children: [
            /* @__PURE__ */ o(D, { children: [
              i && /* @__PURE__ */ a(
                N,
                {
                  as: i.headingLevel,
                  className: g([
                    "titleWrapper",
                    `titleWrapper--${i.size || "extraLarge"}`
                  ]),
                  children: i.title
                }
              ),
              n && /* @__PURE__ */ a(j, { as: n.headingLevel, children: n.subTitle })
            ] }),
            /* @__PURE__ */ a(w, { children: e })
          ] }),
          p && !l && d()
        ]
      }
    )
  ] });
};
V.Item = b;
export {
  V as MarketingDataList
};
